import React from "react";
import { SvgIcon } from "@mui/material";

const ArrowRightIcon = (props) => {
  return (
    <SvgIcon
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
      {...props}
    >
      <rect
        className="arrow-right-1"
        x="37.20594"
        y="110.91571"
        width="155.68742"
        height="77.19203"
      />
      <polygon
        className="arrow-right-1"
        points="191.097 83.188 262.794 151.951 194.031 223.648 191.097 83.188"
      />
    </SvgIcon>
  );
};

export default ArrowRightIcon;
